/* ============================================================================
   OraPath audience switch — dual-mode homepage (individual | provider).
   Sets data-audience on <html>; CSS in op.css shows/hides [data-aud] blocks.
   The no-flash default is set by an inline <head> script in theme.liquid; this
   file wires up persistence, keeps every control in sync, and lets ANY element
   with [data-audience-set] (pills, rail links, inline links, CTA buttons) flip
   the mode — so off-ramps can switch views in place.
   ============================================================================ */
(function () {
  var KEY = 'op-audience';

  function current() {
    return document.documentElement.getAttribute('data-audience') === 'provider'
      ? 'provider' : 'individual';
  }

  function syncControl(sw) {
    var a = current();
    sw.querySelectorAll('[data-audience-set]').forEach(function (btn) {
      var on = btn.getAttribute('data-audience-set') === a;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-active', on);
    });
  }

  function syncAll() {
    document.querySelectorAll('.op-audience-switch').forEach(syncControl);
  }

  function setAudience(a) {
    a = a === 'provider' ? 'provider' : 'individual';
    if (a === current()) return;
    document.documentElement.setAttribute('data-audience', a);
    try { localStorage.setItem(KEY, a); } catch (e) {}
    syncAll();
    document.dispatchEvent(new CustomEvent('op:audience', { detail: { audience: a } }));
  }

  // One delegated handler for every [data-audience-set] trigger on the page.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-audience-set]');
    if (!btn) return;
    e.preventDefault();
    var changed = btn.getAttribute('data-audience-set') !== current();
    setAudience(btn.getAttribute('data-audience-set'));
    // On the homepage, flipping the view via the toggle resets to the top.
    // (Scoped to the toggle control so in-place off-ramp switch links don't jump.)
    if (changed && btn.closest('.op-audience-switch') && document.body.getAttribute('data-template') === 'index') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  // Expose for other scripts / future hooks.
  window.OraPathAudience = { set: setAudience, current: current };

  if (document.readyState !== 'loading') syncAll();
  else document.addEventListener('DOMContentLoaded', syncAll);

  // Re-sync in the theme editor when sections are re-rendered.
  document.addEventListener('shopify:section:load', syncAll);
})();
